import api from './api';

export const getUsers = async (page = 1) => await api.get(`/admin/teachable/users?page=${page}`);

export const registerUser = async (email) => await api.post('/admin/teachable/users', { email });

export const enrollUserInCourse = async (userId, courseId) => await api.post('/admin/teachable/enroll', { userId, courseId });
